import { FieldError, FieldErrors } from 'react-hook-form';

import { track } from 'support/helpers/analytics/analytics';
import { interpolateErrorVariables, parseErrorMessage } from 'support/helpers/formErrors/formErrors';

import { WebEDIError } from './types';

export { interpolateErrorVariables, parseErrorMessage };

/**
 * Extracts all field errors from a react-hook-form errors object
 * and formats them into WebEDIError objects.
 */
export const getAllWebEDIErrors = (
  errors: FieldErrors,
  variables: Record<string, string>,
): Record<string, WebEDIError> => {
  const allErrors: Record<string, WebEDIError> = {};

  function getAllErrors(obj: Record<string, unknown>, parentKey = ''): void {
    if (typeof obj !== 'object' || obj === null) {
      return;
    }

    for (const key of Object.keys(obj)) {
      if (key === 'ref') {
        continue;
      }

      const fullPath = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === 'object' && obj[key]) {
        getAllErrors(obj[key] as Record<string, unknown>, fullPath);
      } else {
        if (key === 'message') {
          const error = parseErrorMessage(obj.message);
          const { title, description } = interpolateErrorVariables(error, variables);
          allErrors[parentKey] = {
            id: parentKey,
            fieldPath: parentKey,
            title,
            description,
            type: (obj as FieldError).type,
            severity: 'error',
            isFormError: true,
          };
        }
      }
    }
  }

  getAllErrors(errors);
  return allErrors;
};

/**
 * Tracks errors related to line item modification groups for analytics.
 */

export const trackItemModificationGroupsError = (error: WebEDIError): void => {
  if (error.id.includes('modification_groups') && error.id.includes('line_items')) {
    track('webedi:line_item_modification_group_error', { error, location: window.location.href });
  }
};
